var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticStyle:{"width":"100%"},attrs:{"clearable":"","value":_vm.value,"filterable":"","placeholder":_vm.placeholder,"loading":_vm.loading},on:{"change":_vm.change}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.uuid,attrs:{"label":item.name,"value":item.uuid}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }